// extracted by mini-css-extract-plugin
module.exports = {"mobile":"styles_mobile__B_mv0","desktop":"styles_desktop__sUyf9"};